
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import draggable from "vuedraggable";
import Pop from "@/views/ai-builder/components/blue-pop.vue";
import Loading from "../../components/loading.vue";
import Job, { JobInfo, WhiteUser, CommonParam, JobExam } from "@/lib/job/job";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import { Template, ExamTemp, TL } from "@/lib/model/template/template";
import AddOne from "@/views/paper/components/add-one-candidate-new-job.vue";
import AddMore from "@/views/paper/components/add-more-candidate-new-job.vue";
import CandidateCreateForm, {
  JobCreateForm
} from "@/lib/form/candidate/CandidateCreateForm";
import Auth from "@/lib/common/auth";
import gateway from "@/lib/request/gateway";
// import ExamLink from "@/components/modal-examlink.vue";
import ExamLink from "@/components/modal-examlink-joblink.vue";

@Component({
  components: {
    draggable,
    Loading,
    Pop,
    AddOne,
    AddMore,
    ExamLink
  }
})
export default class SetQuestion extends Vue {
  // 数据加载完成前不展示空页面
  editing4 = false;
  dataLoaded = false;
  nowJob = new JobInfo(); //左侧当前职位组
  job = new JobInfo(); //右侧当前职位组 详情
  createJobDialog = false;
  createJobParam = new JobInfo();
  jobList: JobInfo[] = [];
  jobExamList: JobExam[] = []; //职位组绑定的面试
  allExamList: ExamV2Custom[] = [];
  tt = "新建职位组";
  tabIndex = 1;
  messageTemplateId = 0;
  emailTemplateId = 0;
  showAddOneDialog = false;
  showAddMoreDialog = false;
  candidateCreateForm = new JobCreateForm();
  whiteList: WhiteUser[] = [];
  pageSize = 10;
  page = 1;
  count = 0;
  showNameOrPhone = "";
  selectRowList: any[] = [];
  messageMultiRadio = true;
  emailMultiRadio = true;
  selectAll = false;
  total = 0;
  linkUrl = "";
  linkImg = "";
  showJobUrl = false;
  showDeleteJob = false;
  limitSW = false;

  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }
  //限制开关切换
  @Watch("job.joinExamLimitSwitch", { deep: true })
  sw1(n: any, o: any) {
    if (n) {
      this.job.joinCandidateLimitSwitch = false;
    }
  }
  @Watch("job.joinCandidateLimitSwitch", { deep: true })
  sw2(n: any, o: any) {
    if (n) {
      this.job.joinExamLimitSwitch = false;
    }
  }
  changeLimit(it: string) {
    this.job[it] = this.job[it] || 2;
    this.updateJob();
  }

  updateJobLimit(open: boolean) {
    if (open) {
      //开启
      this.job.joinExamLimitSwitch = true;
      this.job.joinExamLimit = 2;
      this.job.joinCandidateLimitSwitch = false;
      this.job.joinCandidateLimit = 0;
    } else {
      //关闭
      this.job.joinExamLimitSwitch = false;
      this.job.joinExamLimit = 0;
      this.job.joinCandidateLimitSwitch = false;
      this.job.joinCandidateLimit = 0;
    }
    this.updateJob();
  }
  //表格多选
  getRowKeys(row: any) {
    return row.whiteUserId;
  }
  handleSelectionChange(e: any) {
    this.selectRowList = e;
  }
  get selectIdList() {
    return this.selectRowList.map(row => {
      return row.whiteUserId;
    });
  }
  //切换全选
  changeSelectAll(selected: boolean) {
    (this.$refs.multipleTable as any)?.clearSelection();
    if (selected) {
      (this.$refs.multipleTable as any)?.toggleAllSelection();
    }
  }
  editingJob = new JobInfo(); //编辑时结构
  editTab4() {
    this.editingJob = JSON.parse(JSON.stringify(this.job));
    this.editing4 = true;
  }
  cancelTab4() {
    this.editingJob = new JobInfo();
    this.editing4 = false;
  }
  saveTab4() {
    this.job = JSON.parse(JSON.stringify(this.editingJob));
    this.updateJob();
    this.editing4 = false;
  }
  getPhoneData(p: string) {
    return this.editing4 ? this.editingJob[p] : this.job[p];
  }

  async created() {
    this.getAllExam();
    await this.getJobList();
    //默认选中第一个
    if (this.jobList.length) {
      this.selectJob(this.jobList[0]);
      this.getTempList();
    } else {
      this.dataLoaded = true;
    }
  }

  async mounted() {
    // this.dataLoaded = true;
  }
  //切职位组
  async selectJob(it: JobInfo) {
    this.tabIndex = 1;
    this.nowJob = it;
    this.getJobInfo();
    this.getJobExamList();
    this.getJobTemp();
  }
  getAllExam() {
    Job.getAllExam({ returnAll: true }).then(res => {
      this.allExamList = res.list;
    });
  }
  async getJobList() {
    await Job.getJobList({ pageSize: 100 }).then(res => {
      this.jobList = res.list as Array<JobInfo>;
    });
  }
  async getJobExamList() {
    await Job.getJobExamList({ jobId: this.nowJob.jobId, pageSize: 100 }).then(
      res => {
        this.jobExamList = [];
        res.list.forEach((d: JobExam) => {
          this.jobExamList.push(new JobExam().assign(d));
        });
        this.dataLoaded = true;
      }
    );
  }

  changeTab(i: number) {
    this.tabIndex = i;
    if (i === 3) {
      this.getWhiteList();
    }
  }
  //加个面试
  addOne() {
    const JE = new JobExam();
    JE.editing = true;
    this.jobExamList.push(JE);
  }
  //右侧详情
  getJobInfo() {
    Job.getJobInfo({ jobId: this.nowJob.jobId }).then(res => {
      this.job = res as JobInfo;
      this.limitSW =
        this.job.joinExamLimitSwitch || this.job.joinCandidateLimitSwitch;
    });
  }

  //职位组本身相关
  createJob() {
    if (this.tt === "新建职位组") {
      Job.createJob(this.createJobParam).then(async (res: any) => {
        if (res.code === 0) {
          this.createJobDialog = false;
          await this.getJobList();
          this.$message.success("添加成功");
          this.selectJob(this.jobList[0]);
        } else {
          this.$message.warning("网络错误，请重试");
        }
      });
    } else {
      Job.updateJobName(this.createJobParam).then((res: any) => {
        if (res) {
          this.$message.success("保存成功");
          this.createJobDialog = false;
          this.getJobList();
          this.getJobInfo();
        } else {
          this.$message.warning("网络错误，请重试");
        }
      });
    }
  }
  showCreateJob() {
    this.tt = "新建职位组";
    this.createJobParam.name = "";
    this.createJobParam.loginText = "";
    this.createJobDialog = true;
  }
  showEditJobName() {
    this.createJobParam = JSON.parse(JSON.stringify(this.job));
    this.tt = "编辑职位组";
    this.createJobDialog = true;
  }
  updateJob() {
    Job.updateJob(this.job).then(res => {
      if (res) {
        this.$message.success("保存成功");
      }
    });
  }
  updateJobName() {
    Job.updateJobName({}).then(res => {
      //
    });
  }
  async deleteJob() {
    await Job.deleteJob(this.job).then(async res => {
      if (res) {
        this.$message.success("删除成功");
        this.showDeleteJob = false;
        await this.getJobList();
        if (this.jobList[0]) {
          this.selectJob(this.jobList[0]);
        }
      }
    });
  }

  //职位组关联面试相关
  saveNewJobExam(job: JobExam) {
    job.jobId = this.nowJob.jobId;
    Job.createJobExam(job).then(res => {
      this.$message.success("添加成功");
      job.editing = false;
      this.getJobExamList();
    });
  }
  saveEditJobExam(job: JobExam) {
    Job.updateJobExam(job).then(res => {
      this.$message.success("保存成功");
      job.editing = false;
      this.getJobExamList();
    });
  }
  deleteJobExam(job: JobExam) {
    Job.deleteJobExam(job).then(res => {
      this.$message.success("删除成功");
      this.getJobExamList();
    });
  }
  sortJobExam() {
    const idList: string[] = [];
    this.jobExamList.forEach(d => {
      idList.push(d.examId);
    });
    const p = {
      jobId: this.nowJob.jobId,
      examIdList: idList
    };
    Job.sortJobExam(p).then(res => {
      if (res) {
        //
      }
    });
  }
  showUrl() {
    this.linkUrl = "";
    this.linkImg = "";
    // Job.getJobUrl({ connectCode: this.job.connectCode }).then(res => {
    //   this.linkUrl = res.url;
    // });
    // Job.getJobImg({ connectCode: this.job.connectCode }).then(res => {
    //   this.linkImg = "data:image/png;base64," + res.base64string;
    // });
    this.showJobUrl = true;
  }

  getExamName(id: number) {
    const res = this.allExamList.find(e => {
      return e.examId === id;
    });
    return res?.name;
  }
  getWhiteList(toFirst = "") {
    if (toFirst) {
      this.page = 1;
    }
    Job.getWhiteList({
      jobId: this.job.jobId,
      page: this.page,
      pageSize: this.pageSize,
      showNameOrPhoneOrEmail: this.showNameOrPhone
    }).then(res => {
      if (res) {
        this.whiteList = res.list;
        this.count = res.count;
        this.total = res.count;
      }
    });
  }
  showAddOne() {
    this.candidateCreateForm.jobId = this.job.jobId;
    this.showAddOneDialog = true;
  }

  showAddMore() {
    this.showAddMoreDialog = true;
  }

  addOneSuccess() {
    this.getWhiteList();
    this.showAddOneDialog = false;
  }
  addMoreSuccess() {
    this.getWhiteList();
    this.showAddMoreDialog = false;
  }
  //通知白名单
  noticeWhiteOne(row: any) {
    Job.sendWhite({
      whiteUserId: row.whiteUserId,
      jobId: this.job.jobId,
      sendMobile: true,
      sendEmail: true
    }).then(res => {
      if (res) {
        this.$message.success("通知已发送");
      }
    });
  }
  sendParam: any = {};
  //群发接口
  async sendAskSubmitMulti() {
    if (this.selectAll) {
      //全选、
      if (this.total > 2000) {
        this.$message.warning("单次最多通知【前2000条】");
      }
      this.sendParam.whiteUserIdList = await this.getAllId();
    } else {
      //多选
      this.sendParam.whiteUserIdList = this.selectIdList.map(r => {
        return r;
      });
    }
    this.sendParam.sendEmail = this.emailMultiRadio;
    this.sendParam.sendMobile = this.messageMultiRadio;
    this.sendParam.jobId = this.job.jobId;
    Job.sendWhiteM(this.sendParam).then(resp => {
      if (resp) {
        this.$message.success("发送成功");
      } else {
        // this.$message.error(resp.message);
      }
    });
  }
  //查询所有id
  async getAllId() {
    return await Job.getAllId({
      jobId: this.job.jobId,
      showNameOrPhoneOrEmail: this.showNameOrPhone
    }).then((res: any) => {
      if (res.data.code === 0) {
        return res.data.data.whiteUserIdList || [];
      }
    });
  }
  //删除白名单
  delWhiteOne(row: any) {
    Job.deleteWhite({
      whiteUserId: row.whiteUserId,
      jobId: this.job.jobId
    }).then(res => {
      if (res) {
        this.$message.success("删除成功");
        this.getWhiteList();
      }
    });
  }
  async delWhiteMore() {
    let list = [];
    if (this.selectAll) {
      //全选、
      if (this.total > 2000) {
        this.$message.warning("单次最多删除【前2000条】");
      }
      list = await this.getAllId();
    } else {
      //多选
      list = this.selectIdList.map(r => {
        return r;
      });
    }
    Job.deleteWhiteM({ jobId: this.job.jobId, whiteUserIdList: list }).then(
      res => {
        if (res) {
          this.$message.success("删除成功");
          setTimeout(() => {
            this.getWhiteList("toFirst");
          }, 500);
        }
      }
    );
  }
  //所有短信 邮件 模板list
  async getTempList() {
    const p1 = Template.getTemplateList({
      type: 1,
      auditStatusList: [1],
      returnAll: true
    }).then(res => {
      this.phoneTempList = res.data.data.list;
      // this.$nextTick(() => (this.messageTemplateId = 85));
    });
    const p2 = Template.getTemplateList({
      type: 2,
      auditStatusList: [1],
      returnAll: true
    }).then(res => {
      this.emailTempList = res.data.data.list;
      // this.$nextTick(() => (this.emailTemplateId = 86));
    });
    await Promise.all([p1, p2]).then(res => {
      this.getJobTemp();
      return true;
    });
  }
  getJobTemp() {
    //默认值 or 保存值
    Job.getJobTemplate({ jobId: this.nowJob.jobId }).then(res => {
      this.messageTemplateId = res.templateList.find((d: any) => {
        return d.type === 1;
      }).templateId;
      this.emailTemplateId = res.templateList.find((d: any) => {
        return d.type === 2;
      }).templateId;
    });
  }
  saveTemplate() {
    const list = [
      { env: 20, type: 1, templateId: this.messageTemplateId },
      { env: 20, type: 2, templateId: this.emailTemplateId }
    ];
    Job.saveJobTemplate({ jobId: this.job.jobId, templateList: list }).then(
      res => {
        if (res) {
          this.$message.success("保存成功");
        }
      }
    );
  }
  //场景筛选
  phoneTempList: Template[] = [];
  emailTempList: Template[] = [];
  phoneTempListEnv(env: number) {
    return this.phoneTempList.filter(res => res.env === env);
  }
  emailTempListEnv(env: number) {
    return this.emailTempList.filter(res => res.env === env);
  }
  getTextFromId(id: number, type = "phone") {
    if (type === "phone") {
      return (
        this.phoneTempList.find(t => {
          return t.templateId === id;
        }) || new Template()
      );
    } else {
      return (
        this.emailTempList.find(t => {
          return t.templateId === id;
        }) || new Template()
      );
    }
  }

  get token() {
    return Auth.token;
  }
  upLoading = false;
  uploadImg(data: { filename: string; file: File }) {
    const { filename, file } = data;
    console.log(filename);
    this.upLoading = true;
    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
      this.upLoading = false;
      return false;
    }
    if (!isLt2M) {
      this.$message.error("上传图片过大!");
      this.upLoading = false;
      return false;
    }
    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        gateway
          .upload(postRes, file)
          .then((res: any) => {
            console.log("upload res : ", res);
          })
          .finally(() => {
            this.editingJob.companyLogoUrl = tempUrl;
            this.upLoading = false;
          });
      }
    });
  }
  canRefresh = true;
  //刷新
  f5() {
    if (this.canRefresh === true) {
      this.getWhiteList("toFirst");
      this.canRefresh = false;
      setTimeout(() => {
        this.canRefresh = true;
      }, 1000);
    } else {
      // this.$message.warning("太频繁啦");
      return;
    }
  }
}
